import { render, staticRenderFns } from "./UserManagament.vue?vue&type=template&id=406cf45e&scoped=true&lang=pug"
import script from "./UserManagament.vue?vue&type=script&lang=js"
export * from "./UserManagament.vue?vue&type=script&lang=js"
import style0 from "./UserManagament.vue?vue&type=style&index=0&id=406cf45e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406cf45e",
  null
  
)

export default component.exports